import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`All exporters support configuration of a batch span processor with `}<inlineCode parentName="p">{`batch_processor`}</inlineCode>{`. `}</p>
    <p>{`You must tune your `}<inlineCode parentName="p">{`batch_processor`}</inlineCode>{` configuration if you see any of the following messages in your logs:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`OpenTelemetry trace error occurred: cannot send span to the batch span processor because the channel is full`}</inlineCode></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`OpenTelemetry metrics error occurred: cannot send span to the batch span processor because the channel is full`}</inlineCode></p>
      </li>
    </ul>
    <p>{`The exact settings depend on the bandwidth available for you to send data to your application peformance monitor (APM) and the bandwidth configuration of your APM. Expect to tune these settings over time as your application changes.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      